<template>
  <div class="home-page">
    <!-- 轮播图 -->
    <HomeBanner />
    <!-- 服务卡片 -->
    <ServiceCards />
    <!-- 商品分类列表 -->
    <ProductFeed />
  </div>
</template>

<script>
import HomeBanner from '@/components/HomeBanner.vue';
import ServiceCards from '@/components/ServiceCards.vue';
import ProductFeed from '@/components/ProductFeed.vue';

export default {
  name: 'Home',
  components: {
    HomeBanner,
    ServiceCards,
    ProductFeed
  }
};
</script>

<style scoped>
.home-page {
  background: #f7f8fa;
  min-height: 100vh;
  /* padding-bottom 由外部 TabBar 决定，但为了防止内容被遮挡，可以在这里加 padding 或 marginBottom */
  padding-bottom: 20px; 
}
</style>
